import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    downloadingCategoryCreateLoading: false,
    downloadingCategoryCreateSuccess: {},
    downloadingCategoryError: '',
    downloadingListLoading: false,
    downloadingList: [],
    downloadingListError: "",
    loading: false,
    data: {},
    error: null,
    downloadCategoryDataLoading: false,
    downloadCategoryByIdDataSuccess: [],
    downloadCategoryByIdError: '',
    downloadingSubCategoryCreateLoading: false,
    downloadingSubCategoryCreateSuccess: {},
    downloadingSubCategoryError: '',

    downloadSubCategoryDetailsLoading: false,
    downloadSubCategoryDetailsSuccess: {},
    downloadSubCategoryDetailsError: "",
    // downlaod groups
    downloadGroupCreateLoading: false,
    downloadGroupCreateSuccess: {},
    downloadGroupCreateError: '',

    downloadGroupListLoading: false,
    downloadGroupListSuccess: [],
    downloadGroupListError: "",

    activeCategoriesListLoading: false,
    activeCategoryListSuccess: [],
    activeCategoriesListError: "",

    downloadGroupDetailsLoading: false,
    downloadGroupDetailsSuccess: {},
    downloadGroupDetailsError: "",

    downloadListLoading: false,
    downloadListSuccess: [],
    downloadListError: "",

    subCategoryByCategoryIdLoading: false,
    subCategoryByCategoryIdSuccess: [],
    subCategoryByCategoryIdError: "",

    downloadGroupByCategoryIdLoading: false,
    downloadGroupByCategoryIdSuccess: [],
    downloadGroupByCategoryIdError: "",

    downloadDetailByIdLoading: false,
    downloadDetailByIdSuccess: {},
    downloadDetailByIdError: "",

    downloadCreateLoading: false,
    downloadCreateSuccess: {},
    downloadCreateError: ""
}

export const downloadSlice = createSlice({
    name: 'download',
    initialState,
    reducers: {

        resetDownloadDetail: (state) => {
            state.loading = false
            state.data = {};
            state.error = null
        },
        resetDownloadCreateDetails: (state) => {
            state.downloadingCategoryCreateLoading = false
            state.downloadingCategoryCreateSuccess = {}
            state.downloadingCategoryError = ''
        },
        resetDownloadSubCategoryDetail: (state) => {
            state.downloadSubCategoryDetailsLoading = false;
            state.downloadSubCategoryDetailsSuccess = {};
            state.downloadSubCategoryDetailsError = "";
        },
        resetDownloadSubCategoryCreateDetails: (state) => {
            state.downloadingSubCategoryCreateLoading = false;
            state.downloadingSubCategoryCreateSuccess = {};
            state.downloadingCategoryError = '';
        },
        resetDownloadGroup: (state) => {
            state.downloadGroupCreateLoading = false;
            state.downloadGroupCreateSuccess = {};
            state.downloadGroupCreateError = '';
        },

        resetDownload: (state) => {
            state.downloadCreateLoading = false;
            state.downloadCreateSuccess = {};
            state.downloadCreateError = "";
            state.downloadDetailByIdSuccess = {}

        },
        setDownloadCategoriesLoading: (state) => {
            state.downloadingCategoryCreateLoading = true;
            state.downloadingCategoryCreateSuccess = null;
            state.downloadingCategoryError = '';
        },
        setDownloadCategoriesSuccess: (state, action) => {
            state.downloadingCategoryCreateLoading = false;
            state.downloadingCategoryCreateSuccess = action.payload;
            state.downloadingCategoryError = '';
        },
        setDownloadCategoriesError: (state, action) => {
            state.downloadingCategoryCreateLoading = false;
            state.downloadingCategoryCreateSuccess = null;
            state.downloadingCategoryError = action.payload;
        },
        setDownloadingListLoading: (state) => {
            state.downloadingListLoading = true
        },
        setDownloadingListSuccess: (state, action) => {
            state.downloadingListLoading = false;
            state.downloadingList = action.payload
            state.downloadingListError = ""
        },
        setDownloadingListError: (state, action) => {
            state.downloadingListLoading = false;
            state.downloadingList = [];
            state.downloadingListError = action.payload
        },
        getDownladingDataLoading: (state) => {
            state.loading = true
        },
        setDownloadingDataSuccess: (state, action) => {
            state.loading = true;
            state.data = action.payload.data
            state.error = ""
        },
        setDownloadingDataError: (state, action) => {
            state.loading = false;
            state.data = {};
            state.error = action.payload
        },

        setActiveCategoriesLoading: (state, action) => {
            state.activeCategoriesListLoading = true
        },
        setActiveCategoriesSuccess: (state, action) => {
            state.activeCategoriesListLoading = false;
            state.activeCategoryListSuccess = action.payload.data.map((item) => ({ ...item, label: item.title, value: item.id }));
            state.activeCategoriesListError = ""
        },
        setActiveCategoriesError: (state, action) => {
            state.activeCategoriesListLoading = false;
            state.activeCategoryListSuccess = [];
            state.activeCategoriesListError = action.payload.message
        },
        // reducer for sub category list
        setCategoryByDownloadData: (state, action) => {
            state.downloadCategoryDataLoading = true
        },
        setCategoryByDownloadDataSuccess: (state, action) => {
            state.downloadCategoryDataLoading = false;
            state.downloadCategoryByIdDataSuccess = action.payload
            state.downloadCategoryByIdError = ""
        },
        setCategoryByDownloadDataError: (state, action) => {
            state.downloadCategoryDataLoading = false;
            state.downloadCategoryByIdDataSuccess = [];
            state.downloadCategoryByIdError = action.payload
        },

        // download subcategory create 

        setDownloadSubCategoriesLoading: (state, action) => {
            state.downloadingSubCategoryCreateLoading = true;
            state.downloadingSubCategoryCreateSuccess = null;
            state.downloadingCategoryError = '';
        },
        setDownloadSubCategoriesSuccess: (state, action) => {
            state.downloadingSubCategoryCreateLoading = false;
            state.downloadingSubCategoryCreateSuccess = action.payload;
            state.downloadingSubCategoryError = '';
        },
        setDownloadSubCategoriesError: (state, action) => {
            state.downloadingSubCategoryCreateLoading = false;
            state.downloadingSubCategoryCreateSuccess = null;
            state.downloadingSubCategoryError = action.payload;
        },

        setDownloadSubCategoriesDetailsLoading: (state, action) => {
            state.downloadSubCategoryDetailsLoading = true;
            state.downloadSubCategoryDetailsSuccess = {};
            state.downloadSubCategoryDetailsError = "";
        },
        setDownloadingSubCategoiresDetailsSuccess: (state, action) => {
            state.downloadSubCategoryDetailsLoading = false;
            state.downloadSubCategoryDetailsSuccess = action.payload.data.result;
            state.downloadSubCategoryDetailsError = "";
        },

        setDownloadingSubCategoiresDetailsError: (state, action) => {
            state.downloadSubCategoryDetailsLoading = false;
            state.downloadSubCategoryDetailsSuccess = {}
            state.downloadSubCategoryDetailsError = "";
        },


        // create download group reducer
        setDownloadGroupCreateLoading: (state, action) => {
            state.downloadGroupCreateLoading = false;
            state.downloadGroupCreateSuccess = {};
            state.downloadGroupCreateError = '';

        },
        setDownloadGroupCreateSuccess: (state, action) => {
            state.downloadGroupCreateLoading = false;
            state.downloadGroupCreateSuccess = action.payload;
            state.downloadGroupCreateError = '';

        },
        setDownloadGroupCreateError: (state, action) => {
            state.downloadGroupCreateLoading = false;
            state.downloadGroupCreateSuccess = {};
            state.downloadGroupCreateError = action.payload.message;

        },
        setDownloadGroupListLoading: (state, action) => {
            state.downloadGroupListLoading = true
        },
        setDownloadGroupListSuccess: (state, action) => {
            state.downloadGroupListLoading = false;
            state.downloadGroupListSuccess = action.payload;
            state.downloadGroupListError = ""
        },
        setDownloadGroupListError: (state, action) => {
            state.downloadGroupListLoading = false;
            state.downloadGroupListSuccess = [];
            state.downloadGroupListError = action.payload.message
        },

        getDownloadGroupDetailsLoading: (state, action) => {
            state.downloadGroupDetailsLoading = true
        },
        getDownloadGroupDetailsSuccess: (state, action) => {
            state.downloadGroupDetailsLoading = false;
            state.downloadGroupDetailsSuccess = action.payload.data.result;
            state.downloadGroupDetailsError = ""
        },
        getDownloadGroupDetailsError: (state, action) => {
            state.downloadGroupDetailsLoading = false;
            state.downloadGroupDetailsSuccess = [];
            state.downloadGroupDetailsError = action.payload.message
        },


        // download list 

        getDownloadListLoading: (state, action) => {
            state.downloadListLoading = true;
            state.downloadListSuccess = [];
            state.downloadListError = ""
        },
        getDownloadingListSuccess: (state, action) => {
            state.downloadListLoading = false;
            state.downloadListSuccess = action.payload
            state.downloadListError = ""

        },
        getDownloadingListError: (state, action) => {
            state.downloadListLoading = false;
            state.downloadListSuccess = [];
            state.downloadListError = action.payload.message
        },

        getActiveSubCategoryByCategoryIdLoading: (state, action) => {
            state.subCategoryByCategoryIdLoading = true
        },

        getActiveSubCategoryByCategoryIdSuccess: (state, action) => {
            state.subCategoryByCategoryIdLoading = false;
            state.subCategoryByCategoryIdSuccess = action.payload.data.map((item) => ({ ...item, label: item.title, value: item.id }))
            state.subCategoryByCategoryIdError = ""

        },
        getActiveSubCategoryByCategoryIdError: (state, action) => {
            state.subCategoryByCategoryIdLoading = false;
            state.subCategoryByCategoryIdSuccess = []
            state.subCategoryByCategoryIdError = action.payload.message
        },

        getActiveDownloadGroupByCategoryIdLoading: (state, action) => {
            state.downloadGroupByCategoryIdLoading = true;
            state.downloadGroupByCategoryIdSuccess = [];
            state.downloadGroupByCategoryIdError = "";
        },

        getActiveDownloadGroupByCategoryIdSuccess: (state, action) => {
            state.downloadGroupByCategoryIdLoading = false;
            state.downloadGroupByCategoryIdSuccess = action.payload.data.map((item) => ({ ...item, label: item.title, value: item.id }))
            state.downloadGroupByCategoryIdError = "";
        },
        getActiveDownloadGroupByCategoryIdError: (state, action) => {
            state.downloadGroupByCategoryIdLoading = false;
            state.downloadGroupByCategoryIdSuccess = [];
            state.downloadGroupByCategoryIdError = action.payload.message
        },

        getDownloadDetailsByIdLoading: (state, action) => {
            state.downloadDetailByIdLoading = true;
        },
        getDownloadDetailsByIdSuccess: (state, action) => {
            state.downloadDetailByIdLoading = false;
            state.downloadDetailByIdSuccess = action.payload.data
            state.downloadDetailByIdError = ""
        },
        getDownloadDetailsByIdError: (state, action) => {
            state.downloadDetailByIdLoading = false;
            state.downloadDetailByIdSuccess = {};
            state.downloadDetailByIdError = action.payload.message

        },
        setDownloadCreateLoading: (state, action) => {
            state.downloadCreateLoading = true;
            state.downloadCreateSuccess = {};
            state.downloadCreateError = ""
        },
        setDownloadCreateSuccess: (state, action) => {
            state.downloadCreateLoading = false;
            state.downloadCreateSuccess = action.payload
            state.downloadCreateError = ""

        },
        setDownloadCreateError: (state, action) => {
            state.downloadCreateLoading = false;
            state.downloadCreateSuccess = {};
            state.downloadCreateError = action.payload.message
        }






    },
})

// Action creators are generated for each case reducer function
export const { setDownloadCategoriesLoading, setDownloadCategoriesSuccess, setDownloadCategoriesError,
    setDownloadingListLoading,
    setDownloadingListSuccess,
    setDownloadingListError,
    getDownladingDataLoading,
    setDownloadingDataSuccess,
    setDownloadingDataError,
    resetDownloadDetail,
    resetDownloadCreateDetails,
    setCategoryByDownloadData,
    setCategoryByDownloadDataSuccess,
    setCategoryByDownloadDataError,
    setDownloadSubCategoriesLoading,
    setDownloadSubCategoriesSuccess,
    setDownloadSubCategoriesError,
    setDownloadGroupCreateLoading,
    setDownloadGroupCreateSuccess,
    setDownloadGroupCreateError,
    setDownloadGroupListLoading,
    setDownloadGroupListSuccess,
    setDownloadGroupListError,
    setDownloadSubCategoriesDetailsLoading,
    setDownloadingSubCategoiresDetailsSuccess,
    setDownloadingSubCategoiresDetailsError,
    resetDownloadSubCategoryDetail,
    resetDownloadSubCategoryCreateDetails,
    setActiveCategoriesLoading,
    setActiveCategoriesSuccess,
    setActiveCategoriesError,
    getDownloadGroupDetailsLoading,
    getDownloadGroupDetailsSuccess,
    getDownloadGroupDetailsError,
    getDownloadListLoading,
    getDownloadingListSuccess,
    getDownloadingListError,
    getActiveSubCategoryByCategoryIdLoading,
    getActiveSubCategoryByCategoryIdSuccess,
    getActiveSubCategoryByCategoryIdError,
    getActiveDownloadGroupByCategoryIdLoading,
    getActiveDownloadGroupByCategoryIdSuccess,
    getActiveDownloadGroupByCategoryIdError,
    getDownloadDetailsByIdLoading,
    getDownloadDetailsByIdSuccess,
    getDownloadDetailsByIdError,
    resetDownloadGroup,
    setDownloadCreateLoading,
    setDownloadCreateSuccess,
    setDownloadCreateError,
    resetDownload
} = downloadSlice.actions

export default downloadSlice.reducer;